import React, {Component} from 'react';
import {HeadingSmall, ParagraphLarge} from 'baseui/typography';
import {StyledLink} from 'baseui/link';
import { ListItem, ListItemLabel } from "baseui/list";
import { FlexGrid, FlexGridItem } from 'baseui/flex-grid';
import { Button, SIZE, KIND } from 'baseui/button';
import * as ROUTES from '../../Routes';

import LinuxStoreSnap from '../../images/platforms/linux/linux_store_snapshot.png';
import SnapStoreBadge from '../../images/platforms/linux/snap_store_badge';

const arch_logo = "https://res.cloudinary.com/canonical/image/fetch/f_auto,q_auto,fl_sanitize,w_48,h_48/https://assets.ubuntu.com/v1/feca0fc0-Distro_Logo_ArchLinux.svg";
const centos_logo = "https://res.cloudinary.com/canonical/image/fetch/f_auto,q_auto,fl_sanitize,w_48,h_48/https://assets.ubuntu.com/v1/acf876d9-Distro_Logo_CentOS.svg";
const debian_logo = "https://res.cloudinary.com/canonical/image/fetch/f_auto,q_auto,fl_sanitize,w_48,h_48/https://assets.ubuntu.com/v1/cfdc1144-Distro_Logo_Debian.svg";
const elementary_logo = "https://res.cloudinary.com/canonical/image/fetch/f_auto,q_auto,fl_sanitize,w_48,h_48/https://assets.ubuntu.com/v1/c0c09661-Distro_Logo_Elementary.svg";
const fedora_logo = "https://res.cloudinary.com/canonical/image/fetch/f_auto,q_auto,fl_sanitize,w_48,h_48/https://assets.ubuntu.com/v1/c93d842f-fedora.png";
const kde_logo = "https://res.cloudinary.com/canonical/image/fetch/f_auto,q_auto,fl_sanitize,w_48,h_48/https://assets.ubuntu.com/v1/d0593902-Distro_Logo_KDE+Neon.svg";
const kubuntu_logo = "https://res.cloudinary.com/canonical/image/fetch/f_auto,q_auto,fl_sanitize,w_48,h_48/https://assets.ubuntu.com/v1/7ab50a06-Distro_Logo_Kubuntu.svg";
const manjaro_logo = "https://res.cloudinary.com/canonical/image/fetch/f_auto,q_auto,fl_sanitize,w_48,h_48/https://assets.ubuntu.com/v1/4635a0bd-Distro_Logo_Manjaro.svg";
// const mint_logo = "https://res.cloudinary.com/canonical/image/fetch/f_auto,q_auto,fl_sanitize,w_48,h_48/https://assets.ubuntu.com/v1/938d67b4-Distro_Logo_LinuxMint.svg";
const suse_logo = "https://res.cloudinary.com/canonical/image/fetch/f_auto,q_auto,fl_sanitize,w_48,h_48/https://assets.ubuntu.com/v1/610301c6-Distro_Logo_OpenSUSE.svg";
const redhat_logo = "https://res.cloudinary.com/canonical/image/fetch/f_auto,q_auto,fl_sanitize,w_48,h_48/https://assets.ubuntu.com/v1/be89e41a-red-hat-2019-primary-stacked.svg";
const ubuntu_logo = "https://res.cloudinary.com/canonical/image/fetch/f_auto,q_auto,fl_sanitize,w_48,h_48/https://assets.ubuntu.com/v1/100386fb-Distro_Logo_Ubuntu.svg";


const centerProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};

class Linux extends Component {

    renderSupportedPlatforms = () => {
        return <ul
            style={{
                minWidth: '300px',
                width: '600px',
                maxWidth: '800px',
                paddingLeft: 0,
                paddingRight: 0,
            }}
        >
            <ListItem
                artwork={props => <img alt={''} width={'32px'} src={arch_logo}/>}
                endEnhancer={() => (<Button $as={"a"} href={"https://snapcraft.io/install/enclock/arch"} target="_blank" size={SIZE.compact}>Install</Button>)}
            >
                <ListItemLabel>Arch Linux</ListItemLabel>
            </ListItem>
            <ListItem
                artwork={props => <img alt={''} width={'32px'} src={centos_logo}/>}
                endEnhancer={() => (<Button $as={"a"} href={"https://snapcraft.io/install/enclock/centos"} target="_blank" size={SIZE.compact}>Install</Button>)}
            >
                <ListItemLabel>CentOS</ListItemLabel>
            </ListItem>
            <ListItem
                artwork={props => <img alt={''} width={'32px'} src={debian_logo}/>}
                endEnhancer={() => (<Button $as={"a"} href={"https://snapcraft.io/install/enclock/debian"} target="_blank" size={SIZE.compact}>Install</Button>)}
            >
                <ListItemLabel>Debian</ListItemLabel>
            </ListItem>
            <ListItem
                artwork={props => <img alt={''} width={'32px'} src={elementary_logo}/>}
                endEnhancer={() => (<Button $as={"a"} href={"https://snapcraft.io/install/enclock/elementary"} target="_blank" size={SIZE.compact}>Install</Button>)}
            >
                <ListItemLabel>Elementary OS</ListItemLabel>
            </ListItem>
            <ListItem
                artwork={props => <img alt={''} width={'32px'} src={fedora_logo}/>}
                endEnhancer={() => (<Button $as={"a"} href={"https://snapcraft.io/install/enclock/fedora"} target="_blank" size={SIZE.compact}>Install</Button>)}
            >
                <ListItemLabel>Fedora</ListItemLabel>
            </ListItem>
            <ListItem
                artwork={props => <img alt={''} width={'32px'} src={kde_logo}/>}
                endEnhancer={() => (<Button $as={"a"} href={"https://snapcraft.io/install/enclock/kde-neon"} target="_blank" size={SIZE.compact}>Install</Button>)}
            >
                <ListItemLabel>KDE Neon</ListItemLabel>
            </ListItem>
            <ListItem
                artwork={props => <img alt={''} width={'32px'} src={kubuntu_logo}/>}
                endEnhancer={() => (<Button $as={"a"} href={"https://snapcraft.io/install/enclock/kubuntu"} target="_blank" size={SIZE.compact}>Install</Button>)}
            >
                <ListItemLabel>Kubuntu</ListItemLabel>
            </ListItem>
            <ListItem
                artwork={props => <img alt={''} width={'32px'} src={manjaro_logo}/>}
                endEnhancer={() => (<Button $as={"a"} href={"https://snapcraft.io/install/enclock/manjaro"} target="_blank" size={SIZE.compact}>Install</Button>)}
            >
                <ListItemLabel>Manjaro</ListItemLabel>
            </ListItem>
            <ListItem
                artwork={props => <img alt={''} width={'32px'} src={suse_logo}/>}
                endEnhancer={() => (<Button $as={"a"} href={"https://snapcraft.io/install/enclock/opensuse"} target="_blank" size={SIZE.compact}>Install</Button>)}
            >
                <ListItemLabel>openSUSE</ListItemLabel>
            </ListItem>
            <ListItem
                artwork={props => <img alt={''} width={'32px'} src={redhat_logo}/>}
                endEnhancer={() => (<Button $as={"a"} href={"https://snapcraft.io/install/enclock/rhel"} target="_blank" size={SIZE.compact}>Install</Button>)}
            >
                <ListItemLabel>Red Hat Enterprise Linux</ListItemLabel>
            </ListItem>
            <ListItem
                artwork={props => <img alt={''} width={'32px'} src={ubuntu_logo}/>}
                endEnhancer={() => (<Button $as={"a"} href={"https://snapcraft.io/install/enclock/ubuntu"} target="_blank" size={SIZE.compact}>Install</Button>)}
            >
                <ListItemLabel>Ubuntu</ListItemLabel>
            </ListItem>
        </ul>
    };

    renderDetails = () => {
        return <FlexGrid>
            <FlexGridItem>
                <FlexGrid backgroundColor={'primaryB'} style={{padding: '20px'}}>
                    <FlexGridItem><HeadingSmall margin={0}>EncLock Linux</HeadingSmall></FlexGridItem>
                    <FlexGridItem>
                        <ParagraphLarge>
                        Since its debut on Snap Store on July 11, 2021, EncLock has been helping Linux users secure their files, passwords, notes, and more. Compatible with many Linux distributions, EncLock offers robust local protection for your sensitive data. While cloud sync is not currently supported, rest assured that your data remains secure on your local machine.
                        </ParagraphLarge>
                   
                        <ParagraphLarge>
                        Whether you're running Ubuntu, Fedora, Debian, or another supported distro, installing EncLock is simple. Choose the option tailored for your distribution from the links on our website, or head straight to the EncLock Snap Store page to get started today.
                        </ParagraphLarge>
                    </FlexGridItem>
                    <FlexGridItem {...centerProps}>
                        <Button href={ROUTES.ENCLOCK_LINUX_INSTALL} $as={'a'} target={"_blank"} size={SIZE.mini} kind={KIND.tertiary}>{SnapStoreBadge()}</Button>
                    </FlexGridItem>
                </FlexGrid>
            </FlexGridItem>
        </FlexGrid>
    };

    renderImages = () => {
        return <FlexGrid>
            <FlexGridItem {...centerProps}>
                <StyledLink href={ROUTES.ENCLOCK_LINUX_INSTALL} style={{textAlign: 'center'}} target={"_blank"}><img alt={''} width={'50%'} src={LinuxStoreSnap}/></StyledLink>
            </FlexGridItem>
        </FlexGrid>
    };

    render = () => {
        return <div>
            <FlexGrid>
                <FlexGridItem>{this.renderDetails()}</FlexGridItem>
                <FlexGridItem {...centerProps}><HeadingSmall style={{textAlign: 'center'}}>Supported Linux distributions</HeadingSmall></FlexGridItem>
                <FlexGridItem {...centerProps}>{this.renderSupportedPlatforms()}</FlexGridItem>
                <FlexGridItem {...centerProps}><ParagraphLarge style={{textAlign: 'center'}}>... and more!</ParagraphLarge></FlexGridItem>
            </FlexGrid>
        </div>
    };
}

export default Linux;
